/**
 * WORKING EXAMPLE - JSON Forms Editor for MOSFET Model Parameters
 *
 * This is a corrected version that works with JSONForms vanilla renderers.
 *
 * KEY INSIGHT: JSONForms vanilla renderers handle flat schemas best.
 * Use Group layouts for visual organization instead of nested objects.
 *
 * Copy and paste this into your browser console to test:
 */

// Working example with flat schema (recommended approach)
window.openJsonEditor({
  schema: {
    type: "object",
    title: "Level-1 MOSFET Model",
    properties: {
      // Model identification fields (flat, not nested)
      modelName: {
        type: "string",
        title: "Model name",
        pattern: "^[a-zA-Z][a-zA-Z0-9_]*$",
        default: "nmos1"
      },
      type: {
        type: "string",
        title: "MOSFET Type",
        enum: ["NMOS", "PMOS"],
        default: "NMOS"
      },
      level: {
        type: "integer",
        title: "SPICE Level",
        enum: [1, 2, 3],
        enumNames: ["Level 1 (Shichman-Hodges)", "Level 2 (Geometry-based)", "Level 3 (Semi-empirical)"],
        default: 1
      },
      // Parameters are flat (not in a nested object)
      // This works better with JSONForms vanilla renderers
      VTO: {
        type: "number",
        title: "Threshold Voltage (VTO)",
        description: "Zero-bias threshold voltage in volts",
        minimum: -5,
        maximum: 5,
        default: 0.7
      },
      KP: {
        type: "number",
        title: "Transconductance (KP)",
        description: "Transconductance parameter in A/V²",
        minimum: 0,
        default: 0.00002
      },
      LAMBDA: {
        type: "number",
        title: "Channel Length Modulation (λ)",
        description: "Channel-length modulation parameter in 1/V",
        minimum: 0,
        maximum: 1,
        default: 0.02
      },
      GAMMA: {
        type: "number",
        title: "Body Effect Parameter (γ)",
        description: "Body-effect parameter",
        minimum: 0,
        default: 0.5
      },
      PHI: {
        type: "number",
        title: "Surface Potential (φ)",
        description: "Surface potential in volts",
        minimum: 0,
        default: 0.8
      }
    },
    required: ["modelName", "type", "level"]
  },

  // Use Group layout for visual organization instead of nested objects
  uiSchema: {
    type: "VerticalLayout",
    elements: [
      {
        type: "Group",
        label: "Model Information",
        elements: [
          { type: "Control", scope: "#/properties/modelName" },
          { type: "Control", scope: "#/properties/type" },
          { type: "Control", scope: "#/properties/level" }
        ]
      },
      {
        type: "Group",
        label: "Electrical Parameters",
        elements: [
          { type: "Control", scope: "#/properties/VTO" },
          { type: "Control", scope: "#/properties/KP" }
        ]
      },
      {
        type: "Group",
        label: "Secondary Parameters",
        elements: [
          { type: "Control", scope: "#/properties/LAMBDA" },
          { type: "Control", scope: "#/properties/GAMMA" },
          { type: "Control", scope: "#/properties/PHI" }
        ]
      }
    ]
  },

  data: {
    modelName: "nmos1",
    type: "NMOS",
    level: 1,
    VTO: 0.7,
    KP: 0.00002,
    LAMBDA: 0.02,
    GAMMA: 0.5,
    PHI: 0.8
  },

  title: "Edit MOSFET Model Parameters",

  onSave: (updatedJson) => {
    console.log("Saved JSON:", updatedJson);

    // Generate SPICE .model line
    const { modelName, type, level, VTO, KP, LAMBDA, GAMMA, PHI } = updatedJson;

    // Build parameter string (only include params that differ from defaults)
    const params = [];
    if (VTO !== undefined && VTO !== 0) params.push(`VTO=${VTO}`);
    if (KP !== undefined) params.push(`KP=${KP}`);
    if (LAMBDA !== undefined && LAMBDA !== 0) params.push(`LAMBDA=${LAMBDA}`);
    if (GAMMA !== undefined && GAMMA !== 0) params.push(`GAMMA=${GAMMA}`);
    if (PHI !== undefined && PHI !== 0.8) params.push(`PHI=${PHI}`);

    const paramStr = params.join(" ");
    const modelLine = `.model ${modelName} ${type}(LEVEL=${level} ${paramStr})`;

    console.log("Generated SPICE line:", modelLine);
    alert(`Generated SPICE line:\n${modelLine}`);

    // You can now pass modelLine to your ngspice backend
  }
});

/**
 * ALTERNATIVE: If you really need nested structure in your data,
 * flatten it for the editor and reconstruct it in onSave:
 */

window.openJsonEditorAdvanced = function() {
  // Your nested data structure
  const nestedData = {
    modelName: "nmos1",
    type: "NMOS",
    level: 1,
    parameters: {
      VTO: 0.7,
      KP: 0.00002,
      LAMBDA: 0.02,
      GAMMA: 0.5,
      PHI: 0.8
    }
  };

  // Flatten for the editor
  const flatData = {
    ...nestedData,
    ...nestedData.parameters
  };
  delete flatData.parameters;

  window.openJsonEditor({
    schema: {
      type: "object",
      properties: {
        modelName: { type: "string", title: "Model Name", default: "nmos1" },
        type: { type: "string", title: "Type", enum: ["NMOS", "PMOS"], default: "NMOS" },
        level: { type: "integer", title: "Level", enum: [1, 2, 3], default: 1 },
        VTO: { type: "number", title: "VTO (V)", default: 0.7 },
        KP: { type: "number", title: "KP", default: 0.00002 },
        LAMBDA: { type: "number", title: "LAMBDA", default: 0.02 },
        GAMMA: { type: "number", title: "GAMMA", default: 0.5 },
        PHI: { type: "number", title: "PHI", default: 0.8 }
      }
    },
    uiSchema: {
      type: "VerticalLayout",
      elements: [
        { type: "Control", scope: "#/properties/modelName" },
        { type: "Control", scope: "#/properties/type" },
        { type: "Control", scope: "#/properties/level" },
        {
          type: "Group",
          label: "Parameters",
          elements: [
            { type: "Control", scope: "#/properties/VTO" },
            { type: "Control", scope: "#/properties/KP" },
            { type: "Control", scope: "#/properties/LAMBDA" },
            { type: "Control", scope: "#/properties/GAMMA" },
            { type: "Control", scope: "#/properties/PHI" }
          ]
        }
      ]
    },
    data: flatData,
    title: "Edit MOSFET Model",
    onSave: (flatResult) => {
      // Reconstruct nested structure
      const paramKeys = ["VTO", "KP", "LAMBDA", "GAMMA", "PHI"];
      const parameters = {};
      paramKeys.forEach(key => {
        if (flatResult.hasOwnProperty(key)) {
          parameters[key] = flatResult[key];
          delete flatResult[key];
        }
      });

      const nestedResult = {
        ...flatResult,
        parameters
      };

      console.log("Nested result:", nestedResult);
      alert("Saved nested structure:\n" + JSON.stringify(nestedResult, null, 2));
    }
  });
};

console.log("Working examples loaded! Try:");
console.log("1. The main example above (flat schema with Group layouts)");
console.log("2. window.openJsonEditorAdvanced() (flatten/reconstruct pattern)");
